// extracted by mini-css-extract-plugin
module.exports = {"grid":"ArticlesStyle_grid__1OKV_","card":"ArticlesStyle_card__IXw86"};